import { getPath } from '@/router/common'

const baseUrl = {
  title: '任务列表',
  path: 'taskList'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'Task_List',
    component: () =>
      import(/* webpackChunkName: "Task_List" */ '@/views/taskList/index.vue'),
    meta: {
      title: '任务列表'
    }
  }
]